import BazaarVoiceSchema from '@phx-husky/bazaarvoice-schema';
import { useBazaarVoice } from '@phx-husky/use-bazaarvoice';
import { useLocation } from '@reach/router';
import React, { FC, useEffect } from 'react';

import { BazaairVoiceProps } from './models';

const BazaairVoice: FC<BazaairVoiceProps> = ({
  url,
  productData,
  productId,
  brand = '',
  siteUrl,
  lang = '',
}) => {
  const { trackCatalogUpdate } = useBazaarVoice(url);
  const { pathname } = useLocation();

  const productPageURL = new URL(pathname, siteUrl);

  useEffect(() => {
    // @ts-ignore
    if (window.BV && productData && productId) {
      const product = {
        productId,
        productName: productData.productTitle,
        productPageURL: productPageURL.href,
        brandName: brand,
        productImageURL: new URL(productData.heroImage.url),
      };

      trackCatalogUpdate([product], lang);
    }
  }, [productData, productId, brand]);

  if (productData) {
    return (
      <BazaarVoiceSchema
        sku={productData.sku}
        name={productData.productTitle}
        description={productData.descriptionShort}
        image={productData.heroImage.url}
        brand={brand}
        productUrl={productPageURL.href}
      />
    );
  }

  return null;
};

export default BazaairVoice;
